import { FancyInput } from 'components/ui/Inputs';
import { AddressLabels } from 'models/Address';
import React from 'react';
import { setAddressNameContains } from 'redux/services/chuckieSue/addressesParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';

export const LocationNameFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setAddressNameContains(value || undefined));
  }, 300);

  return <FancyInput placeholder={AddressLabels.name} onChange={handleChange} />;
};
